import { render } from "./FatherLineMigrationMap.vue?vue&type=template&id=07ab8458"
import script from "./FatherLineMigrationMap.vue?vue&type=script&lang=js"
export * from "./FatherLineMigrationMap.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__